import React  from 'react';
import useStyles from './styles/ChatToggle.styles';
import Fab from '@material-ui/core/Fab';
import ChatIcon from '@material-ui/icons/Chat';
import Slide from "@material-ui/core/Slide";

/**
 * React Component for handling small and expanded Chat windows.
 * @param props Properties: chatClosed, toggleChat, handlChatWindowToggle(bool)
 * @returns {JSX.Element}
 * @constructor
 */
function ChatToggle(props) {
  const classes = useStyles();

  return (
    <Slide direction="up" in={props.chatClosed} mountOnEnter unmountOnExit onExit={() => window.parent.postMessage(JSON.stringify({'action': 'expand'}),"*")}>
      <Fab className={classes.toggleChat} color="primary" aria-label="add" onClick={() => props.handleChatWindowToggle(false)}>
        {/*<ChatIcon />*/}
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-0.75 -0.75 16 16" stroke="#FFFFFF" aria-hidden="true" height="32" width="32">
          <path stroke-linecap="round" stroke-linejoin="round" d="M5.2109375 7.25a0.2265625 0.2265625 0 1 1 -0.453125 0 0.2265625 0.2265625 0 0 1 0.453125 0Zm0 0H4.984375m2.4921875 0a0.2265625 0.2265625 0 1 1 -0.453125 0 0.2265625 0.2265625 0 0 1 0.453125 0Zm0 0H7.25m2.4921875 0a0.2265625 0.2265625 0 1 1 -0.453125 0 0.2265625 0.2265625 0 0 1 0.453125 0Zm0 0h-0.2265625M12.6875 7.25c0 2.7525833333333334 -2.4347916666666665 4.984375 -5.4375 4.984375a5.899083333333333 5.899083333333333 0 0 1 -1.5436458333333334 -0.20360416666666667A3.6080833333333335 3.6080833333333335 0 0 1 3.2685416666666667 12.669374999999999a3.6062708333333333 3.6062708333333333 0 0 1 -0.286375 -0.03927083333333333 2.7066666666666666 2.7066666666666666 0 0 0 0.5908749999999999 -1.2234375c0.05437499999999999 -0.27610416666666665 -0.08035416666666667 -0.5443541666666667 -0.2821458333333333 -0.7407083333333333C2.374375 9.774208333333334 1.8125 8.572520833333332 1.8125 7.25c0 -2.7525833333333334 2.4347916666666665 -4.984375 5.4375 -4.984375s5.4375 2.2317916666666666 5.4375 4.984375Z" stroke-width="1"></path>
        </svg>
      </Fab>
    </Slide>
  );
}

export default ChatToggle;
